import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
//Material imports
import { useTheme } from "@mui/material/styles";
import withStyles from "@mui/styles/withStyles";
import Grid from "@mui/material/Grid";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { MFASetup, MFA_CTX_SETUP } from "@limitless/portal";
import { useLoginWrapperContext } from "@limitless/expert";
const MFASetupScreen = ({
  classes,
  history,
  ctx
}) => {
  var _history$location, _history$location$sta;
  const log = pilog.getLogger("MFASetupScreen");
  const theme = useTheme();
  const profile = history === null || history === void 0 ? void 0 : (_history$location = history.location) === null || _history$location === void 0 ? void 0 : (_history$location$sta = _history$location.state) === null || _history$location$sta === void 0 ? void 0 : _history$location$sta.profile;
  const {
    mfaLoginState
  } = useLoginWrapperContext();
  const currentScreen = React.useMemo(() => ctx !== null && ctx !== void 0 && ctx.currentScreen || !mfaLoginState.isPhoneNumberVerify ? "submitPhoneScreen" : "mfaVerify", [ctx === null || ctx === void 0 ? void 0 : ctx.currentScreen, mfaLoginState]);
  React.useEffect(() => {
    log.debug("phoneDetails:", profile === null || profile === void 0 ? void 0 : profile._phoneDetails);
    log.debug("mfa:", profile === null || profile === void 0 ? void 0 : profile.mfa);
    log.debug("currentScreen:", currentScreen);
    if (!(profile !== null && profile !== void 0 && profile.userName)) {
      history.replace("/");
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: `${classes.mainContainer} ${classes.screenBackgroundPng}`
  }, /*#__PURE__*/React.createElement("img", {
    src: theme.assets.logoImg,
    className: classes.imageStyle
  }), profile && /*#__PURE__*/React.createElement(Grid, {
    className: classes.mfaContainer
  }, /*#__PURE__*/React.createElement(MFASetup, {
    mfaCtx: MFA_CTX_SETUP,
    screen: currentScreen,
    verifySuccessCB: () => history.replace("/"),
    profile: profile
  })));
};
const styles = theme => ({
  mainContainer: {
    height: "100vh",
    backgroundPosition: "15%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover"
  },
  screenBackgroundPng: {
    backgroundImage: `url(${theme.assets.signinBackground})`
  },
  imageStyle: {
    paddingTop: 12,
    paddingLeft: 12
  },
  mfaContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: 600,
    paddingLeft: 50,
    paddingRight: 50,
    margin: "auto",
    height: "calc(100vh - 170px)"
  },
  [theme.breakpoints.up("sm")]: {
    mfaContainer: {
      paddingLeft: 100,
      paddingRight: 100,
      height: "calc(100vh - 182px)"
    },
    imageStyle: {
      paddingTop: 24,
      paddingLeft: 24
    },
    mainContainer: {
      backgroundPosition: "17%"
    }
  },
  [theme.breakpoints.up("md")]: {
    mfaContainer: {
      height: "calc(100vh - 260px)"
    },
    imageStyle: {
      paddingTop: 24,
      paddingLeft: 24
    },
    mainContainer: {
      backgroundPosition: "11%"
    },
    "@media (min-height:521px) and (max-height: 800px)": {
      mfaContainer: {
        height: "calc(100vh - 60px)"
      },
      imageStyle: {
        paddingTop: 24,
        paddingLeft: 24
      }
    }
  },
  [theme.breakpoints.up("xl")]: {
    mfaContainer: {
      width: "calc(100% - 12%)"
    },
    mainContainer: {
      backgroundPosition: "0px -2px",
      backgroundSize: "cover"
    }
  }
});
export default withRouter(withStyles(styles)(MFASetupScreen));
MFASetupScreen.propTypes = {
  classes: PropTypes.object.isRequired,
  ctx: PropTypes.object,
  history: PropTypes.object.isRequired
};